// A FIELD THAT FINISHES WHAT IS TYPED (Louis 2026-10-29): the first of `options` that starts with it,
// whatever the case, its rest shown in grey after the cursor, and Tab takes it. Tab with nothing to
// take moves on, as Tab does; so does the Tab after one is taken. Empty, Tab writes the placeholder.
export function CompletingInput({ value, onChange, options, placeholder, autoFocus, className = '' }: {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  placeholder?: string;
  autoFocus?: boolean;
  className?: string;
}) {
  const typed = value.toLowerCase();
  const match = typed ? options.find((o) => o.length > value.length && o.toLowerCase().startsWith(typed)) : undefined;
  const rest = match ? match.slice(value.length) : '';
  // The box is the wrapper's, so the grey can stand behind the transparent field at the same place.
  const box = 'rounded-lg border border-slate-300 px-3 py-2 text-sm';
  return (
    <div className={`relative bg-white ${className} rounded-lg`}>
      {rest && (
        <div aria-hidden className={`pointer-events-none absolute inset-0 overflow-hidden whitespace-pre border-transparent ${box}`}>
          <span className="invisible">{value}</span>
          <span className="text-slate-400">{rest}</span>
        </div>
      )}
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          // EMPTY, IT TAKES ITS OWN PLACEHOLDER as its text (Louis 2026-10-29): "Marque", "Nom du produit".
          const take = match ?? (!value && placeholder ? placeholder : undefined);
          if (e.key !== 'Tab' || e.shiftKey || !take) return;
          e.preventDefault();
          onChange(take);
        }}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className={`relative w-full bg-transparent text-slate-800 ${box}`}
      />
    </div>
  );
}
